/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Markup/theme';

export const MarkupTheme = theme;
